const translation = {
  // Would love to have this under pages, but wanted to match file structure
  catalog: {
    pages: {
      products: {
        index: {
          title: "Product catalog",
          titleSearching: "Searching for “{{keyword}}”",
          resultsCount_one: "{{countString}} product found",
          resultsCount_other: "{{countString}} products found",
          productList: "Product list",
        },
      },
    },
  },

  components: {
    AdUnit: {
      CategoryMenuContentCard: {
        sponsored: "Sponsored",
      },
      ProductCatalogContentCard: {
        sponsored: "Sponsored",
      },
      VendorCatalogContentCard: {
        sponsored: "Sponsored",
      },
    },
    CertificateNotice: {
      getDesignerPricing: "Get designer pricing on SideDoor!",
      expired: "Your resale certificate has expired",
      waitingForVerification: "Your resale certificate is currently being verified by our team",
      genericIssue: "Certificate issue",
      onceVerified:
        "Once you've been verified by the SideDoor team, you'll be able to share collections with clients, view and purchase products at discounted designer rates, and more!",
      uploadCta: "Upload a certificate",
      disclaimer: `SideDoor requires a verified "resale", "sales use & tax" or "wholesale" certificate to use all features.`,
      disclaimerCta: "Learn more or get help",
    },
    Pagination: {
      firstPage: "First page",
      previousPage: "Previous page",
      nextPage: "Next page",
      lastPage: "Last page",
      noResults: "No results",
      resultsCount_one: "Showing {{from}} to {{to}} of {{count}} result",
      resultsCount_other: "Showing {{from}} to {{to}} of {{count}} results",
    },
    ProductCard: {
      createCollectionSuccessNotification: {
        title: "Created collection",
        message: `@@0 was created with product @@1.`,
      },
    },
    ProductPage: {
      contactRep: "Contact rep about this piece",
    },
    SelectionMultiSelectDropdown: {
      confirmDelete_one: "Are you sure you want to remove 1 product from this collection? This can't be undone!",
      confirmDelete_other:
        "Are you sure you want to remove {{count}} products from this collection? This can't be undone!",
      selectedCount_one: "1 product selected",
      selectedCount_other: "{{count}} products selected",
      selectAllLoaded: "Select all loaded products ({{count}})",
      deselectAll: "Deselect all",
      deleteSelected: "Delete selected…",
      deleteSelectedError: "Something went wrong deleting these products. Please try again later.",
      deleteSelectedSuccess: "Successfully removed!",
    },
    VirtualCollections: {
      VirtualCollectionSelect: {
        optionText_Collections: "My collections",
        optionText_Vendor: "My picks by vendor",
        optionText_ProductType: "My picks by product type",
        optionText_ProductCategory: "My picks by product category",
      },
    },
  },

  pages: {
    home: {
      index: {
        emailVerified: "Thanks for verifying your email address!",
      },
    },
  },

  shared: {
    product: {
      wholesalePriceLabel_Market: "Stocking",
      wholesalePriceLabel_FirmsPlus: "Wholesale",
      wholesalePriceLabel_TraditionalSideDoor: "Wholesale",
    },
  },
} as const

export default translation
